<template>
  <div
    class="modal-mask"
    :class="{ white: !popupDark }"
    @click.self="$emit('closePopup')"
  ></div>
</template>

<script>
export default {
  props: {
    popupDark: Boolean,
  },
};
</script>

<style lang="sass" scoped>
.modal-mask
  position: fixed
  z-index: 10003
  top: 50px
  left: 0
  right: 0
  bottom: 90px
  background-color: rgba(15, 18, 19, 0.8)
  &.white
    background-color: rgba($white, .8)
</style>
